import 'babel-polyfill';

import Vue from 'vue';

import svg_icons from './common/svg_icons.vue';

import Slick from 'vue-slick';

// SASS/CSS
import '../../css/sass/public.scss';

// images
import '../../images/icons-public.svg';

// disable the warning about dev/prod
Vue.config.productionTip = false;

new Vue({
    el: '#app',
    components: {
        'svg-icons': svg_icons,
        Slick,
    },
    data: {
        show: false,
        showSub: false,

        slickOptions: {
                slidesToShow: 1,
                infinite: true,
                swipe: true,
                autoplay: true,
                autoplaySpeed: 8000,
                fade: true,
                pauseOnHover: false,
                zindex: 1,
                // dots: true,
                // lazyload: progressive,
                // Any other options that can be got from plugin documentation
        },
        faq1: false,
        faq2: false,
        faq3: false,
        faq4: false,
        faq5: false,
        faq6: false,
        faq7: false,
        faq8: false,
        faq9: false,
        faq10: false,
        faq11: false,
        bio1: false,
        bio2: false,
        bio3: false,
        bio4: false,
        bio5: false,
        bio6: false,
        bio7: false,
        bio8: false,
        bio9: false,
    },
    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', this.windowResize);
        });
    },

    methods: {

        faqToggle1(e) {
           this.faq1 = !this.faq1
           e.preventDefault();
        },

        faqToggle2(e) {
           this.faq2 = !this.faq2
           e.preventDefault();
        },
        faqToggle3(e) {
           this.faq3 = !this.faq3
           e.preventDefault();
        },
        faqToggle4(e) {
           this.faq4 = !this.faq4
           e.preventDefault();
        },
        faqToggle5(e) {
           this.faq5 = !this.faq5
           e.preventDefault();
        },
        faqToggle6(e) {
           this.faq6 = !this.faq6
           e.preventDefault();
        },
        faqToggle7(e) {
           this.faq7 = !this.faq7
           e.preventDefault();
        },
        faqToggle8(e) {
           this.faq8 = !this.faq8
           e.preventDefault();
        },
        faqToggle9(e) {
           this.faq9 = !this.faq9
           e.preventDefault();
        },
        faqToggle10(e) {
           this.faq10 = !this.faq10
           e.preventDefault();
        },
        faqToggle11(e) {
           this.faq11 = !this.faq11
           e.preventDefault();
        },

        bioToggle1(e) {
           this.bio1 = !this.bio1
           e.preventDefault();
        },

        bioToggle2(e) {
           this.bio2 = !this.bio2
           e.preventDefault();
        },
        bioToggle3(e) {
           this.bio3 = !this.bio3
           e.preventDefault();
        },
        bioToggle4(e) {
           this.bio4 = !this.bio4
           e.preventDefault();
        },
        bioToggle5(e) {
           this.bio5 = !this.bio5
           e.preventDefault();
        },
        bioToggle6(e) {
           this.bio6 = !this.bio6
           e.preventDefault();
        },
        bioToggle7(e) {
           this.bio7 = !this.bio7
           e.preventDefault();
        },
        bioToggle8(e) {
           this.bio8 = !this.bio8
           e.preventDefault();
        },
        bioToggle9(e) {
           this.bio9 = !this.bio9
           e.preventDefault();
        },

        toggle(e) {
           this.show = !this.show
           e.preventDefault();
        },
        toggleSub(e) {
           this.showSub = !this.showSub
           e.preventDefault();
        },

       windowResize() {
            this.show = false;
        },

        //Slick
        next() {
            this.$refs.slick.next();
        },

        prev() {
            this.$refs.slick.prev();
        },

        reInit() {
            // Helpful if you have to deal with v-for to update dynamic lists
            this.$refs.slick.reSlick();
        },
    },
});


// WEBPACK FOOTER //
// ./html/js/src/public.js